var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancela(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-1",
    cx: 16,
    cy: 16,
    rx: 16,
    ry: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#ellipse-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(205,45,55)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3,
    mask: "url(#mask-2)",
    xlinkHref: "#ellipse-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(205,45,55)",
    fillRule: "evenodd",
    d: "M20.45112232 9.8444349l1.70466893 1.70466988-4.45098898 4.45098648 4.45092175 4.45092425-1.7046699 1.70466893-4.45092174-4.45092424-4.45092424 4.45092174-1.70466894-1.70466989 4.45092425-4.45092174-4.45100806-4.45101056 1.70466989-1.70466894 4.45100806 4.45101056 4.45098898-4.45098648z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancela);
export default __webpack_public_path__ + "static/media/cancela.b7c4d837b00549245713cb4c7e00e90e.svg";
export { ForwardRef as ReactComponent };